export enum RealEstateEditAction {
  Create = 'create',
  Publish = 'publish',
  AskPublish = 'askPublish',
}
